import { useEffect, useRef, useState } from "react";

export const Speeds = {
  x1: 600,
  x2: 200,
  x3: 25,
};

const useTour = (positions = []) => {
  const tablePanelRef = useRef();

  const [speed, setSpeed] = useState(Speeds.x1);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isTourMode, setIsTourMode] = useState(false);
  const [currentBusIndex, setCurrentBusIndex] = useState(0);
  const [routeCoordinates, setRouteCoordinates] = useState([]);

  const animateBus = () => {
    if (currentBusIndex < positions.length) {
      setTimeout(() => {
        setCurrentBusIndex((prevIndex) => prevIndex + 1);
      }, speed);
    } else {
      setIsPlaying(false);
    }
  };

  useEffect(() => {
    if (isPlaying) {
      animateBus();
    }
  }, [isPlaying, currentBusIndex]);

  useEffect(() => {
    if (currentBusIndex > 0) {
      const newRoute = positions.slice(0, currentBusIndex + 1);
      scrollToCurrentLocation();
      setRouteCoordinates(newRoute);
    }
  }, [currentBusIndex, positions]);

  const handlePlay = () => {
    if (positions?.length === currentBusIndex + 1) {
      setCurrentBusIndex(0);
    }
    setIsPlaying(true);
    setIsTourMode(true);
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  const handleStop = () => {
    setIsPlaying(false);
    setIsTourMode(false);
    setCurrentBusIndex(0);
    setRouteCoordinates([]);
  };

  const handleSpeedChange = (newSpeed) => {
    setSpeed(newSpeed);
    if (isPlaying) {
      handlePause();
      handlePlay();
    }
  };

  const scrollToCurrentLocation = () => {
    const currentRow = document.querySelector(`.point-${currentBusIndex}`);
    if (tablePanelRef.current && currentRow) {
      const rowTop = currentRow.offsetTop;

      tablePanelRef.current.scrollTo({
        top: rowTop,
        behavior: "smooth",
      });
    }
  };

  const busPoints = routeCoordinates.map((e) => [e.latitude, e.longitude]);
  const currentBusPosition = busPoints[currentBusIndex];

  return {
    speed,
    busPoints,
    isTourMode,
    isPlaying,
    tablePanelRef,
    currentBusIndex,
    currentBusPosition,
    tourHandlers: {
      handlePlay,
      handlePause,
      handleStop,
      handleSpeedChange,
    }
  };
};

export default useTour;
